<template>
    <transition name="pop">
        <div v-if="item" class="view--scroll view-program">
            <header class="header">
                <a class="back" @click="$router.back()">&lt;</a>
                <h1 class="header__name">{{item.name}}</h1>
            </header>
            <article class="contents container">
                <section class="images">
                    <swiper :options="$options.swiper">
                        <swiper-slide v-for="image in item.images" :key="image">
                            <img class="image" :src="image">
                        </swiper-slide>
                    </swiper>
                    <div class="images__dots" slot="pagination"></div>
                </section>
                <section class="titles">
                    <p class="titles__top">
                        <span v-if="item.date">{{item.date}}</span>
                        <span v-else>EVERYDAY</span>
                        <span class="type">{{item.type | programType}}</span>
                    </p>
                    <h1 class="name lined"><span class="mask name__mask">{{item.name}}</span></h1>
                    <h2 class="oneliner">{{item.oneliner}}</h2>
                </section>
                <section class="body row">
                    <div class="col col-12 col640-6">
                        <div>
                            <h1 class="body__heading"><span class="mask">프로그램 소개</span></h1>
                            <p class="body__text">{{item.description}}</p>
                        </div>
                        <div>
                            <h1 class="body__heading"><span class="mask">프로그램 구성</span></h1>
                            <p class="body__text">{{item.contents}}</p>
                        </div>
                    </div>
                    <div class="col col-12 col640-6">
                        <div v-if="item.timetable">
                            <h1 class="body__heading"><span class="mask">날짜 및 시간</span></h1>
                            <p class="body__text">{{item.timetable}}</p>
                        </div>
                        <div v-if="item.captable">
                            <h1 class="body__heading"><span class="mask">참여인원</span></h1>
                            <p class="body__text">{{item.captable}}</p>
                        </div>
                        <div v-if="item.feetable">
                            <h1 class="body__heading"><span class="mask">참여비</span></h1>
                            <p class="body__text">{{item.feetable}}</p>
                        </div>
                        <div v-if="item.note">
                            <h1 class="body__heading"><span class="mask">유의사항</span></h1>
                            <p class="body__text">{{item.note}}</p>
                        </div>
                    </div>
                </section>
                <section class="map">
                    <section-title>LOCATION</section-title>
                    <program-map :spot="item.spot"/>
                </section>
                <section v-if="item.url" class="bottom">
                    <section-title>NOW, BOOK!</section-title>
                    <div class="bottom__wrapper">
                        <p class="bottom__text">매진되기 전에<br>빨리 예약해야 될걸요?</p>
                        <a class="link-button" :href="item.url | httpfy" target="_blank"
                           v-scrollee="{ anchor: 'top' }"
                           @scrollee="handleBottomScrollee"
                           @click="track">프로그램 참여 신청하기</a>
                    </div>
                </section>
                <div v-if="item.url" class="bottom-stickers" :class="{ active_: stickersActive }">
                    <img class="bottom-sticker _n1" src="~@/assets/sticker04.png">
                    <img class="bottom-sticker _n2" src="~@/assets/sticker05.png">
                </div>
            </article>
            <v-track :title="item.title"/>
        </div>
    </transition>
</template>

<script>
import 'swiper/dist/css/swiper.css'

import progress from 'nprogress'
import { swiper, swiperSlide } from 'vue-awesome-swiper/src/index'
import { db } from '@/core/shared'
import { programType } from '@/core/type'
import { meta } from '@/mixins/meta'
import ProgramMap from './ProgramMap'

const fetchItem = async (id) => {
    progress.start()
    const program = await db.collection('programs').doc(id).get()
    if (! program.exists) {
        return false
    }
    const spot = await program.data().linkWith.get()
    progress.done()

    return { ...program.data(), spot: { id: spot.id, ...spot.data() } }
}

export default {
    name: 'ProgramView',
    swiper: {
        autoHeight: true,
        pagination: {
            el: '.images__dots'
        }
    },
    mixins: [meta],
    components: {
        swiper,
        swiperSlide,
        ProgramMap
    },
    filters: {
        programType
    },
    data() {
        return {
            stickersActive: false
        }
    },
    metaInfo() {
        return this.item ? {
            title: this.title,
            meta: [
                this.ogTitle,
                this.ogUrl,
                { name: 'og:description', content: this.item.oneliner },
                { name: 'og:image', content: this.item.images[0] },
                { name: 'og:image_alt', content: this.item.name }
            ]
        } : null
    },
    methods: {
        handleBottomScrollee(e) {
            this.stickersActive = !! e.detail
        },
        track() {
            this.$ga.event('Gyeongridan', 'outbound', this.title)
        }
    },
    async beforeRouteEnter(to, from, next) {
        const program = await fetchItem(to.params.id)
        if (program) {
            next(vm => {
                vm.item = program
            })
        }
        else {
            alert('존재하지 않는 프로그램입니다.')
        }
    },
    async beforeRouteUpdate(to, _, next) {
        const program = await fetchItem(to.params.id)
        if (program) {
            this.item = program
            const coords = { lat: program.spot.coords.latitude, lng: program.spot.coords.longitude }
            this.map.setCenter(coords)
            this.marker.setPosition(coords)
            next()
        }
        else {
            alert('존재하지 않는 프로그램입니다.')
        }
    }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/_parts';

.view-program {
    height: 100%;
    color: #efefef;
    position: relative;
}
.contents {
    position: relative ;
}

.title-mask {
    padding: 0 2em;
}

.header {
    font-weight: 800;
    line-height: em(48);
    position: relative;
    text-align: center;
}
.back {
    position: absolute;
    top: 0;
    left: em(20);
}

.images {
    @include rowpad();
}
.images__dots {
    margin-top: em(12);
}
.image {
    width: 100%;
    display: block;
}

.titles {
    color: #fff;
    margin-top: em(24);
}
.titles__top {
    display: flex;
    align-items: center;
    font-family: 'Fugaz One', sans-serif;
    font-size: em(18);
    text-transform: uppercase;
    @include g-text-shadow();
}
.type {
    margin-left: auto;
}

.name {
    font-size: em(32);
    font-weight: 800;
    margin-top: em(6, 32);
    margin-right: em(-20, 32);
    word-break: keep-all;
    @include media(640) {
        margin-right: 0;
    }
}
.name__mask {
    padding-right: em(24, 32);
}
.oneliner {
    line-height: 1.65em;
    margin-top: em(20);
}

.body {
    font-size: em(14);
    margin-top: em(52, 14);
}
.body__heading {
    color: #fff;
    font-weight: 800;
    @include media(768) {
        @include line(transparentize(#fff, .85))
    }
}
.body__text {
    line-height: em(24, 14);
    margin-top: 1em;
    margin-bottom: em(36, 14);
    white-space: pre-line;
    @include media(768) {
        margin-bottom: em(45, 14);
    }
}

.map {
    margin-top: 3em;
    margin-bottom: em(80);
    position: relative;
    @include rowpad();
}

.bottom__wrapper {
    position: relative;
    z-index: 1;
}
.bottom__text {
    font-size: em(18);
    line-height: em(26, 18);
    text-align: center;
}
.bottom-stickers.active_ .bottom-sticker {
    &._n1 {
        transform: rotate(35deg);
    }
    &._n2 {
        transform: rotate(-30deg);
        transition-delay: 250ms;
    }
}
.bottom-sticker {
    &._n1 {
        width: em(193);
        bottom: em(16);
        left: em(-80);
        transform: translateY(100vh) rotate(25deg);
        transition: transform 750ms $ease-in;
        @include media(640) {
            bottom: em(48);
            left: em(34);
        }
    }
    &._n2 {
        width: em(198);
        right: em(-98);
        top: em(23);
        transform: translateY(100vh) rotate(-30deg);
        transition: transform 650ms $ease-in;
        @include media(640) {
            top: em(53);
            right: em(34);
        }
        @include media(768) {
            top: em(123);
        }
    }
}
</style>